import {EnumUtils} from './utils/EnumUtils';

export enum PermissionTargetEnum {
  ANALYSIS = 'ANALYSIS',
  DASHBOARD = 'DASHBOARD',
  FILES = 'FILES',
  GROUPS = 'GROUPS',
  PERMISSIONS = 'PERMISSIONS',
  USERS_PASSWORD = 'USERS_PASSWORD',
  USERS = 'USERS',
  SCRAPER = 'SCRAPER',
  FIRMWARE = 'FIRMWARE',
  MODULE_TYPE = 'MODULE_TYPE',
  DISPLAY_TYPE = 'DISPLAY_TYPE',
  CHIP_TYPE = 'CHIP_TYPE',

  NO_PERMISSION = 'NO_PERMISSION'
}

export namespace PermissionTargetEnum {
  export function getAll(): PermissionTargetEnum[] {
    return EnumUtils.getAll<PermissionTargetEnum>(PermissionTargetEnum, 'string');
  }

  export function getEnumByValue(value: string): PermissionTargetEnum {
    return EnumUtils.getEnumByValue<PermissionTargetEnum>(PermissionTargetEnum, 'string', value);
  }
}
